import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Table from "../../../tables/components/Table";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import useUpcomingDeliveries from "./hooks/useUpcomingDeliveries";
import useUpcomingDeliveriesColumns from "./hooks/useUpcomingDeliveriesColumns";

export default function UpcomingDeliveriesWidget({ organization }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const [data, loading, error] = useUpcomingDeliveries({ organization });

	const columns = useUpcomingDeliveriesColumns();

	const getDropdownMenuOptions = (production) => [
		{
			text: t("toProduction", "To production"),
			linkTo: `/production/${production.id}`,
		},
	];

	return (
		<HomeLayout.Widget icon="sync" color="red" header={t("commingDeliveries", "Upcoming deliveries")}>
			<Table
				data={data || []}
				error={error}
				columns={columns}
				loading={loading}
				onClick={({ production }) => navigate(`/production/${production.id}`)}
				getDropdownMenuOptions={getDropdownMenuOptions}
				noDataAvailableMessage={t("noUpcomingDeliveries", "You have no upcoming deliveries")}
			/>
		</HomeLayout.Widget>
	);
}
